import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { getLocalStorage } from '@app/shared/helpers/helper';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DynamicComponentService {
  private headers!: HttpHeaders;
  private apiBff = environment.url.apiBff;

  constructor(private http: HttpClient) {}

  obtenerComponentesDinamicos(
    rutDv: string,
    businessLine?: string,
    policies?: string
  ): Observable<any> {
    const token = getLocalStorage('token');
    let url = `${this.apiBff}/BffSitioPrivado/DynamicBannerModal/${rutDv}`;

    const params = [];
    if (businessLine) {
      params.push(`BusinessLine=${encodeURIComponent(businessLine)}`);
    }
    if (policies) {
      params.push(`Policies=${encodeURIComponent(policies)}`);
    }
    if (params.length > 0) {
      url += `?${params.join('&')}`;
    }    this.headers = new HttpHeaders({
      'accept': 'application/json',
      'x-application': 'Sitio Privado',
      'x-ibm-client-id': environment.ClientId,
      'Authorization': 'Bearer ' + token.access_token,
    });

    return this.http.get(url, { headers: this.headers });
  }
}
